'use client';
import { Breadcrumb, Container, PublicPageHeading } from '@/components';
import { useTranslation } from '@/hooks';
import { routes } from '@/statics';

const StaticSections: React.FC = () => {
  const { t } = useTranslation('pages');

  return (
    <>
      <Container gap={{ base: 2.5, md: 5 }}>
        <Breadcrumb
          list={[
            { title: t('home.home'), href: routes.home.url },
            {
              title: routes.categories.title,
              href: routes.categories.url,
            },
          ]}
        />
      </Container>
      <PublicPageHeading title={t('categories.storeLong')} />
    </>
  );
};
export default StaticSections;
